module.exports = __webpack_public_path__ + "static/img/cqjy.621a66c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/userVal/cqjy.png
// module id = wEHi
// module chunks = 0